import React, { useEffect, useMemo } from 'react';
import { LoginPage } from './LoginPage';
import { Query, UrlUtil } from '@hugendubel/utils';
import { TokenChecks } from '@hugendubel/ws_client';
import { useSub } from '../../store';
import { OAuthService } from '../../services/oauth-service';
import { useLocation } from 'react-router-dom';

export const Authorize: React.FC = () => {
    const { wsToken } = useSub(({ wsToken }) => ({ wsToken: wsToken }));
    const loginRequired = useMemo(() => wsToken && !TokenChecks.isCustomer(wsToken), [wsToken]);
    const { search } = useLocation();
    const query = UrlUtil.locationSearchToQuery(search) as Query;

    const triggerRetry = useSub(({ triggerRetry }) => triggerRetry);
    const client_id = query.client_id;
    const response_type = query.response_type?.toLowerCase();
    const scope = query.scope?.toLowerCase();
    const redirect_uri = query.redirect_uri?.toLowerCase();

    useEffect(() => {
        if (!loginRequired) {
            OAuthService.getAuthCodeAndRedirect({ client_id, response_type, scope, redirect_uri });
        }
    }, [loginRequired, client_id, response_type, scope, redirect_uri, triggerRetry]);

    return loginRequired ? <LoginPage /> : null;
};
